// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_fz","seoBlockContent_visible":"c-a_fA"};